<a
  [routerLink]="url()"
  routerLinkActive
  [routerLinkActiveOptions]="{ exact: url() === '/' }"
  #rla="routerLinkActive"
  [class]="rla.isActive ? ['side-menu--active', 'side-menu'] : 'side-menu'"
>
  <gc-icon [iconName]="icon()" [size]="'medium'" />
  <gc-text [variant]="'information'">{{ label() }}</gc-text>
</a>
